if (!customElements.get('image-carousel')) {
  customElements.define(
    'image-carousel',
    class ImageCarousel extends HTMLElement {
      static DEFAULT_OPTIONS = {
        cellAlign: 'left',
        contain: true,
        groupCells: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        imagesLoaded: true,
        percentPosition: false,
      };

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.destroy();
      }

      init() {
        this.querySelectorAll('[data-image-carousel]').forEach((el) => this.initCarousel(el));
      }

      destroy() {
        this.querySelectorAll('[data-image-carousel]').forEach((el) => {
          if (el.flickityInstance) {
            el.flickityInstance.destroy();
            el.flickityInstance = null;
          }
          el.controlHandlers = null;
        });
      }

      setupControls(el, flkty) {
        const prevButton = this.querySelector('.image-carousel__prev');
        const nextButton = this.querySelector('.image-carousel__next');
        const dotsContainer = this.querySelector('.image-carousel__dots');

        if (!prevButton || !nextButton || !dotsContainer) return;

        if (el.controlHandlers) {
          prevButton.removeEventListener('click', el.controlHandlers.prev);
          nextButton.removeEventListener('click', el.controlHandlers.next);
          flkty.off('select', el.controlHandlers.update);
        }

        function updateControls() {
          const slideCount = flkty.slides.length;
          const canWrap = flkty.options.wrapAround;
          const disableNav = slideCount <= 1;

          prevButton.disabled = disableNav || (!canWrap && flkty.selectedIndex === 0);
          nextButton.disabled = disableNav || (!canWrap && flkty.selectedIndex === slideCount - 1);

          dotsContainer.innerHTML = '';
          flkty.slides.forEach((slide, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'image-carousel__dot';
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
            dot.setAttribute('aria-selected', index === flkty.selectedIndex ? 'true' : 'false');
            if (index === flkty.selectedIndex) {
              dot.classList.add('is-selected');
            }
            dot.addEventListener('click', () => flkty.select(index));
            dotsContainer.appendChild(dot);
          });
        }

        const prevHandler = () => flkty.previous();
        const nextHandler = () => flkty.next();

        prevButton.addEventListener('click', prevHandler);
        nextButton.addEventListener('click', nextHandler);
        flkty.on('select', updateControls);
        updateControls();

        el.controlHandlers = {
          prev: prevHandler,
          next: nextHandler,
          update: updateControls,
        };
      }

      initCarousel(el) {
        if (!el || typeof Flickity === 'undefined') return;

        if (el.flickityInstance) {
          el.flickityInstance.destroy();
          el.flickityInstance = null;
        }

        let options = { ...ImageCarousel.DEFAULT_OPTIONS };
        if (el.dataset.flickityOptions) {
          try {
            options = { ...options, ...JSON.parse(el.dataset.flickityOptions) };
          } catch (error) {
            console.warn('Image carousel: invalid Flickity options', error);
          }
        }
        
        const flkty = new Flickity(el, options);
        el.flickityInstance = flkty;
        this.setupControls(el, flkty);
      }
    }
  );
}
